import {authHeader} from '../_helpers'
import axios from 'axios'
import {API_URL} from './user.service'

export const detailedReportService = {
  getReports
}

async function getReports (options) {
  // //console.log(options,'dadad')
  const reports = await axios.post(`${API_URL}/report/person_detailed`,
    options,
    {headers: authHeader()}
  )
  return reports.data
}



// WEBPACK FOOTER //
// ./src/_services/detailed-report.service.js